import VerifyAccount, { TVerifyBusiness } from '../VerifyAccount/VerifyAccount';
import ConfirmAccountContext from '../../contexts/ConfirmAccountContext';
import { parseUserBusinesses } from '../../util/helpers';
import { TBusiness, TUser } from '../../util/types';
import GlobalContext from '../../contexts/GlobalContext';
import API from '../../api/api';
import { FC, useContext, useEffect, useState } from 'react';
import PageLayoutV2 from '../../layout/PageLayoutV2/PageLayoutV2';

export type TConfirmAccountRouterState = {
    familyAccountData: {
        primaryUser: TUser;
        businesses: TBusiness[];
        legacySyncToken: string;
    };
};

enum EConfirmAccountSuccessUiState {
    default,
    ready,
}

const ConfirmAccountSuccess: FC = () => {
    const { language } = useContext(GlobalContext);
    const { businesses, firstName, lastName, userId, legacySyncToken, confirmFamilySuccessData } =
        useContext(ConfirmAccountContext);
    const [parsedBusinesses, setParsedBusinesses] = useState<TVerifyBusiness[]>([]);
    const [primaryUser, setPrimaryUser] = useState<TUser>({ id: '', firstName: '', lastName: '' });
    const [hasFamily, setHasFamily] = useState(false);
    const [syncToken, setSyncToken] = useState('');
    const [confirmAccountSuccessUiState, setConfirmAccountSuccessUiState] = useState(
        EConfirmAccountSuccessUiState.default,
    );

    const parseInitialData = () => {
        if (confirmFamilySuccessData) {
            const parsedBusinesses = parseUserBusinesses({
                businesses: confirmFamilySuccessData.businesses,
                primaryUserId: confirmFamilySuccessData.primaryUser.id,
            });
            setPrimaryUser(parsedBusinesses.primaryUser);
            setParsedBusinesses(parsedBusinesses.businesses);
            setHasFamily(parsedBusinesses.hasFamilyUsers);
            setPrimaryUser(parsedBusinesses.primaryUser);
            setSyncToken(confirmFamilySuccessData.legacySyncToken);
        } else {
            setParsedBusinesses(businesses);
            setPrimaryUser({ firstName, lastName, id: userId });
            setHasFamily(false);
            setSyncToken(legacySyncToken);
        }
    };

    useEffect(() => {
        parseInitialData();
        setConfirmAccountSuccessUiState(EConfirmAccountSuccessUiState.ready);
        API.post.trackEvent({ event: 'Sign In || Verification Complete' });
    }, []);

    if (confirmAccountSuccessUiState !== EConfirmAccountSuccessUiState.ready) {
        return null;
    }

    return (
        <PageLayoutV2>
            <VerifyAccount
                title={language.confirmAccount.success}
                businesses={parsedBusinesses}
                primaryUser={primaryUser}
                hasFamilyUsers={hasFamily}
                legacySyncToken={syncToken}
                onFindBusinesses={() => {
                    API.post.trackEvent({
                        event: 'Sign In || Verification Complete | Button - Search for them (Manual Sync)',
                    });
                }}
            />
        </PageLayoutV2>
    );
};

export default ConfirmAccountSuccess;
